import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { EmailTemplate } from '../../../interfaces/examiner/EmailTemplate';
import request from '../../../api';

interface Props {
  template: EmailTemplate
  open: boolean
  onClose: () => void
  onUpdated: () => void
}

interface State {
  subject: string
  body: string
  saving: boolean
}

export default class EditEmailTemplateDialog extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props)
    this.state = {
      subject: props.template.subject || '',
      body: props.template.body || '',
      saving: false
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.template.id !== this.props.template.id) {
      this.setState({
        subject: this.props.template.subject || '',
        body: this.props.template.body || ''
      })
    }
  }

  handleSubjectChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ subject: e.target.value })
  }

  handleBodyChange = (content: string) => {
    this.setState({ body: content })
  }

  handleSave = async () => {
    this.setState({ saving: true })
    try {
      const res = await request(`/api/examiner/email-templates/${this.props.template.id}`, {
        method: 'PUT',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          subject: this.state.subject,
          body: this.state.body
        })
      })
      if (res.ok) {
        this.props.onUpdated()
      } else {
        const error = await res.text()
        alert('Error saving template: ' + error)
      }
    } catch (error) {
      console.error('Error saving email template:', error)
      alert('Error saving template')
    } finally {
      this.setState({ saving: false })
    }
  }

  render() {
    const { template, open, onClose } = this.props
    const { subject, body, saving } = this.state

    const quillModules = {
      toolbar: [
        [{ 'header': [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'align': [] }],
        ['link'],
        ['clean']
      ]
    }

    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>
          Edit Email Template: {template.name.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
        </DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Subject"
            fullWidth
            value={subject}
            onChange={this.handleSubjectChange}
            helperText="Use {'{{'}variableName{'}}'} for dynamic content (e.g., {'{{'}teacherName{'}}'}, {'{{'}tempPassword{'}}'})"
            style={{ marginBottom: '20px' }}
          />
          <div style={{ marginBottom: '10px' }}>
            <strong>Body:</strong>
            <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
              Use {'{{'}variableName{'}}'} for dynamic content. Available variables: {'{{'}teacherName{'}}'}, {'{{'}tempPassword{'}}'}, {'{{'}schoolCode{'}}'}, {'{{'}loginUrl{'}}'}, {'{{'}competitionShortName{'}}'}, {'{{'}competitionLongName{'}}'}, {'{{'}paymentReference{'}}'}, {'{{'}examTitle{'}}'}, {'{{'}subject{'}}'}, {'{{'}body{'}}'}
            </div>
          </div>
          <ReactQuill
            theme="snow"
            value={body}
            onChange={this.handleBodyChange}
            modules={quillModules}
            style={{ height: '300px', marginBottom: '50px' }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleSave} color="primary" variant="contained" disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}
